import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import BreadCrumb from "../Components/BreadCrumb"
import { useWallet } from "../libs/useMetaMaskWallet"
import { Card, CardBody, CardTitle, CardText } from "reactstrap"

import subdomains from "../constants/subdomains.json"
import ConnectWallet from "../Components/ConnectWallet"
import LootBoxCard from "../Components/LootBoxCard/LootBoxCard"
import NftCard from "../Components/NftCard/NftCard"
import LoadingOrErrorCard from "../Components/LoadingOrErrorCard/LoadingOrErrorCard"
import CountdownTimer from "../Components/CountdownTimer/CountdownTimer"

import { getOpenedNFTs, getUserPaymentBalance, getBoxForSale, getUserPaymentAllowance, getUserBoxCollection, contracts } from "./NFTSale/utils"

const apiUrlNFTSale = "https://whitelist.idexo.io"

const parts = window.location.hostname.split(".") // ['swordsofblood', 'idexo', 'com'], ['localhost'], or ['app', 'idexo', 'io']
const subdomain = parts[0] // 'swordsofblood', 'localhost', 'app'
// const subdomain = "swordsofblood"
// const subdomain = "app"

const headerText = subdomains[subdomain]?.nftSaleHeaderText
const headerText2 = subdomains[subdomain]?.nftSaleHeaderText2
const headerText3 = subdomains[subdomain]?.nftSaleHeaderText3
const nftSaleLoadingTxt = subdomains[subdomain]?.nftSaleLoadingTxt
const nftSaleLoadingTxt2 = subdomains[subdomain]?.nftSaleLoadingTxt2
const nftSaleErrorTxt = subdomains[subdomain]?.nftSaleErrorTxt
const nftSaleErrorTxt2 = subdomains[subdomain]?.nftSaleErrorTxt2
const nftSaleEmptyTxt = subdomains[subdomain]?.nftSaleEmptyTxt
const nftSaleWelcomeTextParagraph1 = subdomains[subdomain]?.nftSaleWelcomeTextParagraph1
const nftSaleWelcomeTextParagraph2 = subdomains[subdomain]?.nftSale1Description
const nftSalePurchasedTextParagraph1 = subdomains[subdomain]?.nftSalePurchasedTextParagraph1
const nftSalePurchasedTextParagraph2 = subdomains[subdomain]?.nftSalePurchasedTextParagraph2
const nftSaleWhitelistSource = subdomains[subdomain]?.nftSaleWhitelistSource
const nftSaleStartTime = subdomains[subdomain]?.nftSaleStartTime // WED Feb 1, 2023 10AM EST (GMT - 5)
const purchaseRequirementTxt = subdomains[subdomain]?.purchaseRequirementTxt

const saleHasStarted = (userType) => {
    if (window.location.pathname === "/nftsaletest") return true // FOR TESTING
    if (userType === "idexo_team") return true // for idexo team
    return nftSaleStartTime < new Date().getTime()
}

const NFTSale = () => {
    // redirect to home if subdomain is not SOB
    const history = useHistory()
    if (subdomain !== "swordsofblood") history.push("/")
    const wallet = useWallet()

    const contractSale = contracts[subdomain]

    const [isConnectedToWallet, setIsConnectedToWallet] = useState(wallet?.status === "connected" && wallet?.chainId === contractSale?.chainId)
    const [showLoadingLootboxes, setShowLoadingLootboxes] = useState(false) // spinner animation for verifying user eligability or fetching loot boxes
    const [showLoadingUserLootBoxes, setShowLoadingUserLootBoxes] = useState(true) // spinner animation for user purchased lootboxes
    const [showLoadingUserNFTs, setShowLoadingUserUserNFTs] = useState(true) // spinner animation for user NFTs from opened lootboxes
    const [errorMessage, setErrorMessage] = useState("") // error alert for verifying user eligability or fetching loot boxes for sale
    const [errorMessagePurchased, setErrorMessagePurchased] = useState("") // error if problem getting user purchased lootbox data
    const [errorMessageUserNFTs, setErrorMessageUserNFTs] = useState("") // error if problem getting user nfts from opened lootboxes
    const [userIsEligible, setUserIsEligible] = useState(false) // whether user is eligible to purchase a lootbox
    const [lootBoxesForSale, setLootBoxesForSale] = useState([]) // lootboxes available for purchase
    const [userLootBoxes, setUserLootBoxes] = useState([]) // lootboxes that the user owns
    const [userNFTs, setUserNFTs] = useState([]) // all NFTs user owns for all loot boxes
    const [userType, setUserType] = useState(null) // SBT holder, whitelisted, or ticket holder

    const [allowance, setAllowance] = useState(0)
    const [balance, setBalance] = useState({ balance: 0, symbol: "", decimals: 0 })

    // a user is eligible to purchase a lootbox if:
    // - 1) holder of Early Adopter SBT
    // - 2) OR queued waitlist and current timestamp > eligible timestamp
    // - 3) OR has ticket and current timestamp > eligible timestamp
    const checkUserEligability = async (subdomain) => {
        setShowLoadingLootboxes(true)
        setErrorMessage("")
        try {
            const res = await fetch(apiUrlNFTSale + `?action=check`, {
                method: "POST",
                body: JSON.stringify({
                    wallet: wallet.account.toLowerCase(),
                    source: nftSaleWhitelistSource
                })
            })
            const response = await res?.json()
            console.log("checkUserEligability", response)

            if (response.code !== 200 || response.error || response?.data?.error) {
                setShowLoadingLootboxes(false)
                return setErrorMessage(response.error || response?.data?.error)
            }
            if (!response?.data?.eligible) return setShowLoadingLootboxes(false)
            setUserIsEligible(true)
            setUserType(response?.data?.type)
            getUserBalance()
            getBoxes() // TO DO: show error if failure getting purchasble boxes
            getAllowance()
            getUserBoxes()
            getUserNfts()
        } catch (err) {
            console.log(String(err))
            setErrorMessage(String(err))
        }
        setShowLoadingLootboxes(false)
    }

    const updateConnection = () => {
        const x = wallet.status === "connected" && wallet?.chainId === contractSale?.chainId
        setIsConnectedToWallet(x)
        return x
    }

    useEffect(() => {
        if (updateConnection() && wallet.account && subdomain !== "app") {
            checkUserEligability(subdomain)
        }
    }, [wallet, wallet.account, wallet.status, wallet.chainId])

    const getUserBalance = async () => {
        const balance = await getUserPaymentBalance(wallet)
        console.log("balance", balance)
        setBalance(balance)
    }

    const getUserBoxes = async () => {
        setShowLoadingUserLootBoxes(true)
        setErrorMessagePurchased("")
        const boxCollection = await getUserBoxCollection(wallet, setErrorMessagePurchased)
        setShowLoadingUserLootBoxes(false)
        setUserLootBoxes(boxCollection)
    }

    const getUserNfts = async () => {
        setShowLoadingUserUserNFTs(true)
        setErrorMessageUserNFTs("")
        const boxCollection = await getOpenedNFTs(wallet, setErrorMessageUserNFTs)
        setShowLoadingUserUserNFTs(false)
        setUserNFTs(boxCollection)
    }

    const getBoxes = async () => {
        const forSale = await getBoxForSale(wallet)
        // console.log("forSale", forSale)
        if (forSale) {
            setLootBoxesForSale(forSale)
        } else {
            setLootBoxesForSale([])
        }
    }

    const getAllowance = async () => {
        const allowed = await getUserPaymentAllowance(wallet)
        console.log("Allowed amount:::", allowed)
        setAllowance(allowed)
    }

    return (
        <React.Fragment>
            <div className="content nft-sale">
                <BreadCrumb items={["NFT Sale"]} />
                {!isConnectedToWallet ? (
                    <Card className="nft-sale-welcome">
                        <CardBody>
                            <CardTitle className="h3">{headerText}</CardTitle>
                            <CardText>{`Connect your Metamask wallet to the ${contractSale?.network}[${contractSale?.chainId}] network to view the page content.`}</CardText>
                            <CardBody>
                                <ConnectWallet wallet={wallet} onChange={updateConnection} isTokenGating={true} />
                            </CardBody>
                        </CardBody>
                    </Card>
                ) : (
                    <React.Fragment>
                        {/* LOOT BOXES AVAILABLE FOR SALE */}
                        <Card className="nft-sale-welcome">
                            <CardBody>
                                <CardTitle className="h3">{headerText}</CardTitle>
                                {showLoadingLootboxes ? (
                                    // text that shows when card is loading
                                    <LoadingOrErrorCard loadingTxt={nftSaleLoadingTxt} className="nft-sale-loading" />
                                ) : (
                                    <React.Fragment>
                                        {errorMessage && (
                                            <LoadingOrErrorCard
                                                // text that shows if there's an error checking the user's eligability
                                                errorTxt={nftSaleErrorTxt}
                                                alertMessage={errorMessage}
                                                className="nft-sale-loading"
                                            />
                                        )}

                                        {/* sale has started & user is NOT eligible to purchase */}
                                        {!errorMessage && saleHasStarted(userType) && !userIsEligible && (
                                            <div className="not-eligible">Sorry you are not eligible for this NFT Sale. {purchaseRequirementTxt}</div>
                                        )}

                                        {/* sale has not yet started, show countdown timer. StartTime = Thurs June 1, 2023 4PM EST (GMT - 5) */}
                                        {!errorMessage && !saleHasStarted(userType) && <CountdownTimer startTime={nftSaleStartTime} />}

                                        {/* sale has started, show available lootboxes to purchase */}
                                        {!errorMessage && saleHasStarted(userType) && true && (
                                            <React.Fragment>
                                                <div className="welcome-message">
                                                    <div className={subdomain}>{nftSaleWelcomeTextParagraph1}</div>
                                                    <div className={subdomain + " welcome-txt-2"}>{nftSaleWelcomeTextParagraph2}</div>
                                                </div>

                                                <div className="nft-sale-card-wrap">
                                                    {lootBoxesForSale?.map((lootbox, idx) => {
                                                        return (
                                                            <LootBoxCard
                                                                lootbox={lootbox}
                                                                idx={idx}
                                                                subdomain={subdomain}
                                                                allowance={allowance}
                                                                balance={balance}
                                                                key={idx}
                                                                contractType="boxCollection"
                                                            />
                                                        )
                                                    })}
                                                </div>
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                )}
                            </CardBody>
                        </Card>

                        {/* PURCHASED/OPENED LOOTBOXES */}
                        {/* only display if saleHasStarted AND user is whitelisted/sbt holder/eligible */}
                        {saleHasStarted(userType) && (
                            <Card className="nft-sale-purchased">
                                <CardBody>
                                    <CardTitle className="h3">{headerText2}</CardTitle>
                                    {showLoadingUserLootBoxes ? (
                                        // text that shows when card is loading
                                        <LoadingOrErrorCard loadingTxt={nftSaleLoadingTxt2} className="nft-sale-loading" />
                                    ) : (
                                        <React.Fragment>
                                            {errorMessagePurchased && (
                                                <LoadingOrErrorCard
                                                    // text that shows if there's an error fetching users purchased lootboxes
                                                    errorTxt={nftSaleErrorTxt2}
                                                    alertMessage={errorMessagePurchased}
                                                    className="nft-sale-loading"
                                                />
                                            )}

                                            {/* show purchased/opened lootboxes */}
                                            {!errorMessagePurchased && (
                                                <React.Fragment>
                                                    <div className="welcome-message">
                                                        <div className={subdomain}>{nftSalePurchasedTextParagraph1}</div>
                                                    </div>

                                                    <div className="nft-sale-card-wrap">
                                                        {userLootBoxes?.map((lootbox, idx) => {
                                                            return (
                                                                <LootBoxCard
                                                                    lootbox={lootbox}
                                                                    idx={idx}
                                                                    subdomain={subdomain}
                                                                    allowance={allowance}
                                                                    balance={balance}
                                                                    key={idx}
                                                                    lootBoxIsPurchased={true} // if true lootbox has been purchased, if false lootbox is available for purchase
                                                                    userNFTs={userNFTs} // ALL user tokens from this collection
                                                                    contractType="boxCollection"
                                                                />
                                                            )
                                                        })}
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </React.Fragment>
                                    )}
                                </CardBody>
                            </Card>
                        )}

                        {/* NFTS FROM OPENED LOOTBOXES */}
                        {/* only display if saleHasStarted AND user is whitelisted/sbt holder/eligible */}
                        {saleHasStarted(userType) && (
                            <Card className="nft-sale-purchased">
                                <CardBody>
                                    <CardTitle className="h3">{headerText3}</CardTitle>
                                    {showLoadingUserNFTs ? (
                                        // text that shows when card is loading
                                        <LoadingOrErrorCard loadingTxt={headerText3} className="nft-sale-loading" />
                                    ) : (
                                        <React.Fragment>
                                            {errorMessageUserNFTs && (
                                                <LoadingOrErrorCard
                                                    // text that shows if there's an error fetching users purchased lootboxes
                                                    errorTxt={"your " + headerText3}
                                                    alertMessage={errorMessageUserNFTs}
                                                    className="nft-sale-loading"
                                                />
                                            )}

                                            {/* show all nfts from opened lootboxes */}
                                            {!errorMessageUserNFTs && (
                                                <React.Fragment>
                                                    <div className="welcome-message">
                                                        <div className={subdomain}>{nftSalePurchasedTextParagraph2}</div>
                                                    </div>

                                                    <div className="nft-sale-card-wrap">
                                                        {userNFTs?.map((nft, idx) => {
                                                            return (
                                                                <NftCard
                                                                    nft={nft}
                                                                    idx={idx}
                                                                    subdomain={subdomain}
                                                                    key={idx}
                                                                    enableClickNFT={true} // if true, clicking on this component will load details page
                                                                    contractType="nftCollection"
                                                                />
                                                            )
                                                        })}
                                                    </div>
                                                </React.Fragment>
                                            )}
                                        </React.Fragment>
                                    )}
                                </CardBody>
                            </Card>
                        )}
                    </React.Fragment>
                )}
            </div>
        </React.Fragment>
    )
}

export default NFTSale
